/* import __COLOCATED_TEMPLATE__ from './blurb.hbs'; */
import Component from "@glimmer/component";
import { inject as service } from "@ember/service";

export default class Blurb extends Component {
  @service siteSettings;
  @service site;
}
